import styled from 'styled-components';

interface IColorProps {
  color: string;
}
export const ColorContainer = styled.div<IColorProps>`
  height: 20px;
  width: 60px;
  border-radius: 4px;
  background: ${(props) => props.color};
`;
